import React from 'react';
import { Box, Typography } from '@mui/material';
import praxisLogo from '../../assets/praxis-logo.png';
import publicBg from '../../assets/public_bg.png';

interface AuthLayoutProps {
  children: React.ReactNode;
  maxWidth?: string;
  showLogo?: boolean;
  showTagline?: boolean;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  maxWidth = '1200px',
  showLogo = true,
  showTagline = true,
}) => {
  return (
    <Box
      sx={{
        height: '100vh',
        overflowY: 'auto',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: `linear-gradient(rgba(8, 12, 24, 0.55), rgba(8, 12, 24, 0.55)), url(${publicBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        px: 2,
        py: 4,
        '&::-webkit-scrollbar': { width: '6px' },
        '&::-webkit-scrollbar-thumb': { bgcolor: 'rgba(255,255,255,0.2)', borderRadius: '3px' },
      }}
    >
      {showLogo && (
        <Box sx={{ textAlign: 'center', mb: 4, flexShrink: 0 }}>
          <img src={praxisLogo} alt="Praxis" style={{ height: 80, marginBottom: 8 }} />
          <Typography variant="h4" fontWeight={700} color="#fff">
            Praxis
          </Typography>
          {showTagline && (
            <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.85)', fontWeight: 500, letterSpacing: '0.5px' }}>
              Knowledge, Skills, Experience
            </Typography>
          )}
        </Box>
      )}

      <Box sx={{ width: '100%', maxWidth, flexShrink: 0 }}>
        {children}
      </Box>
    </Box>
  );
};

export default AuthLayout;
